






import Vue, { PropType } from 'vue';

import {
  Item,
} from 'mostra';

export default Vue.extend({
  name: 'g-item-preview-form',
  props: {
    itemId: {
      type: String as PropType<string>,
      required: true,
    },
    brandId: {
      type: String as PropType<string>,
      required: true,
    },
    item: {
      type: Object as PropType<Item>,
      required: true,
    },
  },
  computed: {
    src(): string {
      return `/ssr/br/${this.brandId}/it/${this.itemId}?pv=1`;
    },
  },
});
